import { atomWithStorage } from 'jotai/utils';

import { Merchant } from 'common/api-types/director';
import { WARP_MERCHANT_STORAGE_KEY } from 'common/constants';

function initialize() {
  try {
    const merchant = localStorage.getItem(WARP_MERCHANT_STORAGE_KEY);
    if (merchant) {
      return JSON.parse(merchant);
    }
  } catch {
    return null;
  }
}

export function invalidateCachedMerchant() {
  // set null instead of removing item to make sure atom works correctly
  localStorage.setItem(WARP_MERCHANT_STORAGE_KEY, JSON.stringify(null));
}

export const warpMerchantAtom = atomWithStorage<Merchant | null>(
  WARP_MERCHANT_STORAGE_KEY,
  initialize(),
);
